export interface FaqItem {
  id: string;
  category: string;
  question: string;
  answer: string;
}

export interface FaqCategory {
  key: string;
  label: string;
  icon: string;
}

export const faqCategories: FaqCategory[] = [
  { key: 'all', label: '全部問題', icon: 'ri-list-unordered' },
  { key: 'fee', label: '收費方式', icon: 'ri-money-dollar-circle-line' },
  { key: 'budget', label: '裝修預算', icon: 'ri-pie-chart-line' },
  { key: 'timeline', label: '工期時程', icon: 'ri-time-line' },
  { key: 'renovation', label: '老店翻新', icon: 'ri-store-2-line' },
  { key: 'process', label: '合作流程', icon: 'ri-flow-chart' },
];

export const faqItems: FaqItem[] = [
  {
    id: 'faq-1',
    category: 'fee',
    question: '設計費如何計算？有最低收費標準嗎？',
    answer: '設計費依空間坪數與服務範疇計費，分為「策略規劃 + 空間設計」與「純空間設計」兩種方案。一般商業空間設計費約從 NT$8,000–15,000 / 坪不等，依案子複雜度、品牌需求深度與設計師資歷有所調整。最低承接規模為 20 坪以上的商業空間。初次諮詢完全免費，我們會在了解需求後提供明確報價，絕不模糊帶過。',
  },
  {
    id: 'faq-2',
    category: 'fee',
    question: '設計費和工程費是分開計算的嗎？費用包含哪些？',
    answer: '是的，設計費與工程費分開報價，讓業主可以清楚知道錢用在哪裡。設計費包含：需求訪談與策略報告、概念設計提案、施工圖說全套（平面、立面、天花、水電、空調等）、材料設備選樣、工程期間監工服務。工程費則依實際施工項目、材料選用與工地條件另行估算，並提供詳細逐項報價單，無隱藏費用。',
  },
  {
    id: 'faq-3',
    category: 'budget',
    question: '開一間餐廳大概要花多少預算？有沒有參考數字？',
    answer: '餐飲空間裝修費用差異很大，以下提供業界常見參考範圍（不含設計費、設備與傢具）：\n\n• 基本翻新（保留大部分隔間，更新表面裝飾）：約 NT$3,000–6,000 / 坪\n• 標準商業裝修（全室翻新含天花水電）：約 NT$6,000–10,000 / 坪\n• 高規格精緻空間（特殊材料、訂製傢具、複雜工法）：NT$12,000 / 坪以上\n\n30 坪的輕食餐廳通常預算在 NT$180–350 萬之間。我們會在了解你的需求與坪數後，提供更精準的預算規劃建議。',
  },
  {
    id: 'faq-4',
    category: 'budget',
    question: '預算不夠，可以分階段施工嗎？',
    answer: '完全可以。我們提供「分階段施工規劃」服務，協助業主在有限預算下，優先完成影響營收與顧客體驗的核心區域，後續再逐步完善其他區域。分階段施工前，我們會先完成整體設計規劃，確保各階段施工風格統一、結構不衝突，避免返工浪費。這個方式特別適合資金有限但希望儘早開業的業主。',
  },
  {
    id: 'faq-5',
    category: 'timeline',
    question: '從諮詢到正式開業，整個流程需要多久時間？',
    answer: '以一般中型商業空間（30–60 坪）為例，整體時程參考如下：\n\n• 需求訪談 + 合約簽署：1–2 週\n• 概念提案 + 設計深化：5–8 週\n• 工程發包 + 進場施工：8–14 週（視工程量）\n• 軟裝陳設 + 驗收交付：1–2 週\n\n合計約 4–6 個月。若有趕工需求（如配合租約或特定開幕日期），我們會協助規劃最佳施工順序，盡量壓縮不必要的等待時間。',
  },
  {
    id: 'faq-6',
    category: 'timeline',
    question: '施工期間我的店不能營業，可以縮短工期嗎？',
    answer: '工期壓縮是可以討論的，但需要在報價前明確說明。縮短工期的方式通常包括：增加施工班組（費用較高）、調整材料選用（選擇乾式工法、模組化材料）、錯開白天與夜間施工（需符合建管法規）。我們在設計階段就會將工期納入規劃考量，評估哪些項目可以前置作業、哪些必須現場施工，在不影響品質的前提下找到最短路徑。',
  },
  {
    id: 'faq-7',
    category: 'renovation',
    question: '老店翻新和全新開店，在規劃上有什麼不同？',
    answer: '老店翻新需要多一個「現況診斷」的前置步驟。我們會先釐清：現有結構哪些可以保留利用？哪些是造成顧客流失的問題點？品牌形象需要調整到什麼程度？這個診斷過程讓翻新方向更精準，避免「為了改而改」浪費預算。另外，老店翻新常遇到管線老化、結構異常、前裝修遺留問題等，我們在現場丈量時會一併評估，確保報價涵蓋實際狀況，不讓業主到施工時才發現追加費用。',
  },
  {
    id: 'faq-8',
    category: 'renovation',
    question: '我的店已經開了幾年，想翻新但不確定問題在哪裡，能提供建議嗎？',
    answer: '這正是我們最擅長的服務之一。我們提供「商業空間健診」服務，在初次諮詢時針對你的空間進行評估，包含：動線流暢度分析、品牌識別一致性、顧客體驗痛點、坪效優化建議。即使你還沒決定要翻新，也可以先透過健診了解問題所在，再決定是否進入設計流程。初次諮詢健診完全免費，讓你可以無壓力地評估。',
  },
  {
    id: 'faq-9',
    category: 'process',
    question: '合作前我需要準備什麼？有沒有什麼資料要先準備？',
    answer: '初次諮詢不需要準備太多，我們會引導整個對話。如果你能提供以下資訊，會讓第一次討論更有效率：\n\n1. 空間地址或大略位置（若尚未確認場地，描述大概坪數即可）\n2. 空間現況照片或平面圖（沒有也沒關係）\n3. 你喜歡的風格或參考案例圖片（可以是 IG 截圖、網路圖片等）\n4. 預計的總預算範圍與希望的開幕時間\n\n帶著這些資訊來，我們就能在一小時內給你有價值的初步建議與方向。',
  },
];
